import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './Home';
import Register from './Register';
import About from './About';
import Login from './components/Login';
import EventDetail from './components/EventDetail'; 
import AlumniDashboard from './components/AlumniDashboard';
import AlumniDirectory from './components/AlumniDirectory';
import ScrollToTop from './ScrollToTop'; 
import ElectionPortal from './components/ElectionPortal'; 
import ForgotPassword from './components/ForgotPassword'; // Update path as needed
import ResetPassword from './components/ResetPassword';
import './App.css';

function App() {  
  return (
    <Router>
      {/* 🌟 2. Place ScrollToTop here to reset view on every click */}
      <ScrollToTop /> 

      <div className="App site-wrapper">
        <Header />

        <div className="content-area">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/about" element={<About />} />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route path="/dashboard" element={<AlumniDashboard />} />
            <Route path="/elections" element={<ElectionPortal />} />
            
            {/* 🌟 3. FIXED: Using AlumniDirectory for the search path */}
            <Route path="/search" element={<AlumniDirectory />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
<Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;